import cookie from "js-cookie";
import Vue from "vue";
export const DEFAULT_OPTIONS = {
  breakpoints: {
    desktop: 1024,
    desktopMedium: 1280,
    desktopWide: 1600,
    mobile: 320,
    mobileMedium: 375,
    mobileWide: 425,
    tablet: 768
  },
  cookieName: "viewport",
  defaultBreakpoints: {
    desktop: "desktop",
    mobile: "mobile",
    tablet: "tablet"
  },
  fallbackBreakpoint: "desktop"
};
export async function detectBreakpoint(cookie2, userAgent) {
  try {
    if (cookie2 && cookie2 in this.breakpoints) {
      return cookie2;
    }
    const {default: UAParser} = await import(
      /* webpackChunkName: "ua-parser-js" */
      "ua-parser-js"
    );
    const parser = new UAParser(userAgent);
    const {type: deviceType = ""} = parser.getDevice();
    if (deviceType in this.defaultBreakpoints) {
      return this.defaultBreakpoints[deviceType];
    }
    return this.fallbackBreakpoint;
  } catch (error) {
    console.error(error);
    return this.fallbackBreakpoint;
  }
}
export function useViewport(options, breakpoint) {
  const instance = new Vue({
    data() {
      return {
        breakpoint
      };
    },
    computed: {
      _queries() {
        const {breakpoints = {}} = options;
        const breakpointsKeys = Object.keys(breakpoints).sort((a, b) => breakpoints[a] - breakpoints[b]);
        const queries = {};
        let i = breakpointsKeys.length;
        while (i--) {
          const currentKey = breakpointsKeys[i];
          const size = breakpoints[currentKey];
          const nextSize = breakpoints[breakpointsKeys[i + 1]];
          let mediaQuery = "";
          if (i > 0) {
            mediaQuery = `(min-width: ${size}px)`;
          } else {
            mediaQuery = `(min-width: 1px)`;
          }
          if (nextSize) {
            mediaQuery += ` and (max-width: ${nextSize - 1}px)`;
          }
          queries[currentKey] = {
            mediaQuery,
            size
          };
        }
        return queries;
      }
    },
    created() {
      if (process.server) {
        return;
      }
      window.onNuxtReady(() => {
        for (const queryKey in this._queries) {
          const {mediaQuery} = this._queries[queryKey];
          const mediaQueryList = window.matchMedia(mediaQuery);
          if (mediaQueryList.matches) {
            this._setBreakpoint(queryKey);
          }
          mediaQueryList.onchange = (event) => {
            if (!event.matches) {
              return;
            }
            this._setBreakpoint(queryKey);
          };
        }
      });
    },
    methods: {
      _setBreakpoint(breakpoint2) {
        this.breakpoint = breakpoint2;
        cookie.set(options.cookieName, breakpoint2, {
          expires: 365,
          sameSite: "strict"
        });
      },
      isGreaterThan(searchBreakpoint) {
        const keys = Object.keys(this._queries);
        const currentIndex = keys.indexOf(this.breakpoint);
        const breakpointIndex = keys.indexOf(searchBreakpoint);
        if (breakpointIndex === -1) {
          return false;
        }
        return breakpointIndex > currentIndex;
      },
      isLessThan(searchBreakpoint) {
        const keys = Object.keys(this._queries);
        const currentIndex = keys.indexOf(this.breakpoint);
        const breakpointIndex = keys.indexOf(searchBreakpoint);
        if (breakpointIndex === -1) {
          return false;
        }
        return breakpointIndex < currentIndex;
      },
      match(breakpointToMatch) {
        return this.breakpoint === breakpointToMatch;
      },
      matches(...breakpointsToMatch) {
        return breakpointsToMatch.includes(this.breakpoint);
      }
    }
  });
  return instance;
}
